import gql from 'graphql-tag'

export const artistResultFragment = gql`
  fragment artistResult on ArtistResult {
    id
    slug
    name
    avatar
  }
`
